/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：285__part-9
 */

"use strict"

import { pt } from "./index__part-8"
import * as /* [auto-meaningful-name] */Module_21 from /* 21 */"../../21"
import { createElement, forwardRef } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_224 from /* 224 */"../../224/index"
var At = function (e, t) {
  return createElement(Module_224.a, Module_21.a(Module_21.a({}, e), {}, {
    ref: t,
    icon: pt
  }))
}
At.displayName = "ExclamationCircleFilled"
var gt = forwardRef(At)
export { gt }
